import { HeaderNull } from '../../../component/HeaderNull'
import { useState } from 'react'
import './NapTienMobile.scss'
import { TrucTuyen } from './TrucTuyen'
import { USDT } from './USDT'

function NapTienMobile () {
  const [tab, settab] = useState('โอนเงินผ่านธนาคาร')
  const data = [
    {
      name: 'โอนเงินผ่านธนาคาร'
    },
    {
      name: 'USDT'
    }
  ]
  return (
    <div>
      <HeaderNull title={'ฝากเงิน'} link={'/usermobile'} />
      <div style={{ marginTop: '110px' }}>
        <div className='tab_naptien'>
          <div
            className={`tab_panel_van ${
              tab === 'โอนเงินผ่านธนาคาร' ? 'tab-login' : 'tab-register'
            }`}
          >
            {data.map((item, index) => (
              <div
                className={`tab_panel_tab ${
                  tab === item.name ? 'tab_panel_tab_active' : ''
                } `}
                onClick={() => settab(item.name)}
                key={index}
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>

        {tab === 'โอนเงินผ่านธนาคาร' && <TrucTuyen />}
        {tab === 'USDT' && <USDT />}
      </div>
    </div>
  )
}

export default NapTienMobile
